import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DataConvertingService } from "src/app/shared/services/data-converting.service";
import { PrintingService } from "src/app/shared/services/printing.service";
import { DocumentListItemDTO } from "../../models/documentListItemsDTO";
import { DocumentListService } from "../../services/documentList.service";

@Component({
  selector: "app-signed-document-preview",
  templateUrl: "./signed-document-preview.component.html",
  styleUrls: ["./signed-document-preview.component.scss"],
})
export class SignedDocumentPreviewComponent implements OnInit {
  @Input() item: DocumentListItemDTO;
  @Output()
  closeSignedDocumentPreview: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  backToPending: EventEmitter<DocumentListItemDTO> = new EventEmitter<DocumentListItemDTO>();
  @Output()
  uploadNew: EventEmitter<DocumentListItemDTO> = new EventEmitter<DocumentListItemDTO>();

  pdf: ArrayBuffer;

  constructor(
    private readonly modalService: NgbModal,
    private readonly service: DocumentListService,
    private readonly printingService: PrintingService,
    private readonly dataService: DataConvertingService
  ) {}

  ngOnInit(): void {
    const url = this.item.signedDocumentUrl;

    // tODO: remove and uncomment below lines when here would be urls from blob storage
    const request = new XMLHttpRequest();
    request.open("GET", url, true);
    request.responseType = "blob";
    request.onload = () => {
      const reader = new FileReader();
      reader.readAsArrayBuffer(request.response);
      reader.onload = (e: any) => {
        this.pdf = e.target.result as ArrayBuffer;
      };
    };
    request.send();
  }

  get rejectionReasonVisible() {
    return this.item.signedButRejected;
  }

  onClose() {
    this.closeSignedDocumentPreview.emit();
  }

  onPrint() {
    const base64 = this.dataService.arrayBufferToBase64(this.pdf);
    this.printingService.print(base64);
  }

  onBackToPending() {
    this.backToPending.emit(this.item);
  }

  onUploadNew() {
    this.uploadNew.emit(this.item);
  }

  get printVisible() {
    return this.item.approved;
  }

  get backToPendingVisible() {
    return this.item.signedButRejected;
  }

  get uploadNewVisible() {
    return this.item.signedButRejected;
  }
}
